<template>
  <div class="AQuestion">
    <div class="title">
      调查问卷
      <p></p>
    </div>

    <el-form class="qu-form" ref="quForm" :rules="rules" :model="form">
      <el-form-item label=" " label-width="80px" prop="problem1">
        <p class="p_txt">1.您是通过什么途径知道这个展会？可多选</p>
        <el-checkbox-group v-model="form.problem1" @change="checkBox1" :disabled="allDisabled">
          <el-checkbox label="网络/官网"></el-checkbox>
          <el-checkbox label="展会邀请函电子邮件"></el-checkbox>
          <el-checkbox label="相关行业协会/学会"></el-checkbox>
          <el-checkbox label="网络/微信/微博平台"></el-checkbox>
          <el-checkbox label="展商或同行邀请"></el-checkbox>
          <el-checkbox label="其他">
            其他，请注明
            <el-input
              v-model="form.cType_qit1"
              :disabled="cType_qita1"
              class="radio_input"
              placeholder="备注"
            ></el-input>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label=" " label-width="80px" class="p_radio" prop="problem2">
        <p class="p_txt">2.请问您的身份？</p>
        <el-radio-group v-model="form.problem2" @change="cTypeRadio" :disabled="allDisabled">
          <el-radio :label="'企业'">企业</el-radio>
          <el-radio :label="'学校'">学校</el-radio>
          <el-radio :label="'媒体'">媒体</el-radio>
          <el-radio :label="'教育行政管理部门、协会、学会'">教育行政管理部门、协会、学会</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label=" " label-width="80px" class="p_radio" prop="problem3">
        <p class="p_txt">3.请问您的行业性质？</p>
        <el-radio-group v-model="form.problem3" @change="cTypeRadio" :disabled="allDisabled">
          <el-radio :label="'经销商/代理商'">经销商/代理商</el-radio>
          <el-radio :label="'投资公司/招投标代理公司'">投资公司/招投标代理公司</el-radio>
          <el-radio :label="'集成商'">集成商</el-radio>
          <el-radio :label="'制造商'">制造商</el-radio>
          <el-radio :label="'教育培训及咨询机构'">教育培训及咨询机构</el-radio>
          <el-radio :label="'教育出版社/教育出版团'">教育出版社/教育出版团</el-radio>
          <el-radio :label="'科研机构'">科研机构</el-radio>
          <el-radio :label="'本科院校'">本科院校</el-radio>
          <el-radio :label="'高职高专'">高职高专</el-radio>
          <el-radio :label="'普教（含中专）'">普教（含中专）</el-radio>
          <el-radio :label="'学前教育'">学前教育</el-radio>
          <el-radio :label="'其他'">
            其他，请注明
            <el-input
              v-model="form.cType_qit3"
              :disabled="cType_qita3"
              class="radio_input"
              placeholder="备注"
            ></el-input>
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label=" " label-width="80px" prop="problem4">
        <p class="p_txt">4.请问您关注哪类产品或服务？可多选</p>
        <el-checkbox-group v-model="form.problem4" @change="checkBox4" :disabled="allDisabled">
          <el-checkbox label="实验室&科研仪器设备与技术类"></el-checkbox>
          <el-checkbox label="信息化&智慧育类"></el-checkbox>
          <el-checkbox label="平安校园&后勤类"></el-checkbox>
          <el-checkbox label="实训&健康类"></el-checkbox>
          <el-checkbox label="寻求集成商/分销商/代理商"></el-checkbox>
          <el-checkbox label="了解行业发展"></el-checkbox>
          <el-checkbox label="专业观众"></el-checkbox>
          <el-checkbox label="行业论坛"></el-checkbox>
          <el-checkbox label="其他">
            其他，请注明
            <el-input
              v-model="form.cType_qit4"
              :disabled="cType_qita4"
              class="radio_input"
              placeholder="备注"
            ></el-input>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>

    <el-button @click="updateBtn">编辑</el-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        problem1: [],
        problem2: "",
        problem3: "",
        problem4: [],
        cType_qit1: "",
        cType_qit3: "",
        cType_qit4: "",
        cType_qit: "",
        cType: "",
      },
      checkList: [],
      cType_qita1: true,
      cType_qita3: true,
      cType_qita4: true,
      allDisabled: true,
      rules: {
        problem1: [
          {
            required: true,
            message: "*为必填项",
            trigger: "change",
          },
        ],
        problem2: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem3: [{ required: true, message: "*为必填项", trigger: "change" }],
        problem4: [
          {
            required: true,
            message: "*为必填项",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.getEventInfo();
  },
  methods: {
    // 个人信息
    getEventInfo() {
      this.$http({
        url: "viewer/viewerInfo",
        method: "get",
      }).then(({ data }) => {
        let { code, user } = data;
        if (code === 0 && user) {
          this.form.id = user.id;
          let parseProblem1 = JSON.parse(user.problem1);
          let parseProblem4 = JSON.parse(user.problem4);
          parseProblem1?this.form.problem1 = JSON.parse(parseProblem1.subset):'';
          this.checkBox1(this.form.problem1);
          parseProblem1?this.form.cType_qit1 = parseProblem1.remarks:'';
          this.form.problem2 = user.problem2;
          this.form.problem3 = user.problem3;
          parseProblem4?this.form.problem4 = JSON.parse(parseProblem4.subset):'';
          this.checkBox4(this.form.problem4);
          parseProblem4?this.form.cType_qit4 = parseProblem4.remarks:'';
        } else {
          this.$message.error("登录失效，请重新登录");
          this.$router.push("/audLogin");
        }
      });
	  // .catch(err => {
   //      this.$message.error("登录失效，请重新登录");
   //        this.$router.push("/audLogin");
   //    })
    },

    cTypeRadio(val) {
      if (val === "其他") {
        this.cType_qita3 = false;
      } else {
        this.cType_qita3 = true;
      }
    },

    updateBtn() {
      if (this.allDisabled) {
        this.allDisabled = false;
      } else {
        this.$refs["quForm"].validate((valid) => {
          if (valid) {
            this.form.problem1 = JSON.stringify({
              subset: JSON.stringify(this.form.problem1),
              remarks: this.form.cType_qit1 || "",
            });
            this.form.problem4 = JSON.stringify({
              subset: JSON.stringify(this.form.problem4),
              remarks: this.form.cType_qit4 || "",
            });
            this.$http({
              url: "viewer/updateViewer",
              method: "post",
              data: this.$http.adornData({
                id: this.form.id,
                name: this.form.pName, // 姓名
                problem1: this.form.problem1,
                problem2: this.form.problem2,
                problem3: this.form.problem3,
                problem4: this.form.problem4,
              }),
            })
              .then(({ data }) => {
                let { code } = data;
                if (code === 0) {
                  this.$message({
                    message: "信息修改成功！",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                      this.getEventInfo();
                      this.up = true;
                    },
                  });
                } else {
                  this.$message.error("修改失败，请稍后重试！");
                }
              })
              .catch((err) => console.log(err));
          }
        });
      }
    },

    checkBox1(val) {
      let haveQT = val.filter((ele) => {
        return ele === "其他";
      });
      if (haveQT.length > 0) {
        this.cType_qita1 = false;
      } else {
        this.cType_qita1 = true;
        this.form.cType_qit1 = "";
      }
    },
    checkBox4(val) {
      let haveQT = val.filter((ele) => {
        return ele === "其他";
      });
      if (haveQT.length > 0) {
        this.cType_qita4 = false;
      } else {
        this.cType_qita4 = true;
        this.form.cType_qit4 = "";
      }
    },
  },
};
</script>
<style lang="scss">
.AQuestion {
  .el-input__inner {
    border-radius: 4px;
    width: 464px;
    height: 42px;
    margin-left: 40px;
  }
  .el-checkbox {
    display: block;
    color: #333333;
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #143372;
    }
    .el-checkbox__inner {
      &:hover {
        border-color: #143372;
      }
    }
  }
  .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
    color: #143372 !important;
  }
  .p_radio {
    .el-radio__input.is-checked .el-radio__inner {
      width: 16px;
      height: 16px;
      background-color: #ffffff;
      border: 2px solid #dcdfe6;
      border-color: #143372;
    }
    .el-radio__inner::after {
      width: 6px;
      height: 6px;
      background-color: #143372;
    }
    .el-radio__inner {
      &:hover {
        border-color: #143372;
      }
    }
  }
  .el-radio {
    display: block;
    height: 40px;
    line-height: 40px;
  }
  .el-radio__inner {
    width: 16px;
    height: 16px;
  }
  .el-radio__label {
    color: #333333;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #333333;
  }
}
</style>
<style lang="scss" scoped>
.AQuestion {
  .title {
    width: 100%;
    height: 66px;
    line-height: 66px;
    font-size: 18px;
    color: #143372;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-indent: 30px;
    margin-bottom: 10px;
    p {
      width: 70px;
      height: 2px;
      background-color: #143372;
      position: absolute;
      bottom: -1px;
      left: 30px;
    }
  }
  .qu-form {
    padding: 50px 115px 0 0;
  }
  .el-button {
    width: 220px;
    height: 54px;
    font-size: 18px;
    color: #ffffff;
    background-color: #143372;
    margin: 48px 0 60px 179px;
  }
}
</style>